export const RecipientChannel = {
  Email: 'Email',
} as const;
export type RecipientChannel = (typeof RecipientChannel)[keyof typeof RecipientChannel];
